<template>
  <div>
    <section class="container page-outer">
      <div class="columns is-offset-2s page">
        <div class="column is-3">
          <div>
            <aside class="menu">
              <p class="menu-label is-size-4 a-heading">ලිපි මාලාව</p>
              <ul class="menu-list">
                <router-link
                  v-for="article in articles"
                  :key="article.id"
                  :to="`${article.id}`"
                  class="a-title"
                  >{{ article.title }}</router-link
                >
              </ul>
            </aside>
          </div>
        </div>
        <div class="is-divider-vertical" />
        <div class="column article"><router-view></router-view></div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "Articles",
  data() {
    return {
      articles: [
        {
          id: "amadoraviwaraviya",
          title: "අමා දොර විවර විය . . ."
        },
        {
          id: "vijam_bana",
          title: "විජම් බණ"
        },
        {
          id: "lowthuru_suwade",
          title: "ලොව්තුරු සුව දේ බුදු හිමි පිළිරූ - නසයි නිවන් මග සදහම් පිළිරූ"
        },
        {
          id: "uthum_mohotha",
          title: "උතුම් මොහොත ඉක්ම නොයවා"
        },
        {
          id: "apannaka_prathipadawa",
          title: "අපණ්ණක ප්‍රතිපදාව නිවැරැදිව හඳුනාගනිමු"
        }
      ]
    };
  }
};
</script>

<style scoped>
.page {
  margin: 30px;
}
/* .page-outer {
  margin-bottom: 50px;
} */
.a-heading {
  background-color: rgba(102, 73, 19, 0.61);
  color: white;
}
.a-title {
  overflow: hidden;
  line-height: 1;
  margin-bottom: 5px;
}
.a-title:hover {
  background-color: rgb(212, 161, 119);
  border-radius: 0.5em;
}

.article {
  border: 1px solid;
  border-color: grey;
  border-radius: 0.8em;
  padding: 20px;
  box-shadow: 5px 10px 5px 10px #888888;
}

.no-scroll {
  /* overflow: auto; */
  width: 25%;
  height: 100vh;

  position: -webkit-sticky;
  position: sticky;
  top: 100px;
}
</style>
